import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.about');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { partnerRows } from "src/libs/portal/season/partner";

interface FocusArea {
    icon: string;
    title: string;
    desc: string;
    path: string;
    eyebrow: string;
    visualType: 'image' | 'oedix';
    image?: string;
    tone: string;
    tags: string[];
}

@Component({
    selector: 'wiz-page-about',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.about/view.scss */
:host {
  display: block;
  font-size: 16px;
}

:host *,
:host *::before,
:host *::after {
  animation: none !important;
  transition: none !important;
  scroll-behavior: auto !important;
}

.section-eyebrow {
  margin-bottom: 14px;
  color: #FE5A33;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 1.35;
  text-transform: uppercase;
}

/* Compact hero */
.about-hero {
  position: relative;
  min-height: 340px;
  display: flex;
  align-items: center;
  overflow: hidden;
  color: #fff;
  background: #11100f;
}

.about-hero-bg,
.about-hero-grid,
.about-hero-lines {
  position: absolute;
  inset: 0;
}

.about-hero-bg {
  background: linear-gradient(120deg, rgba(254, 90, 51, 0.22) 0%, rgba(254, 90, 51, 0) 34%), linear-gradient(135deg, #0C0A09 0%, #181413 52%, #241815 100%);
}

.about-hero-grid {
  opacity: 0.42;
  background-image: linear-gradient(rgba(255, 255, 255, 0.07) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.06) 1px, transparent 1px);
  background-size: 56px 56px;
  mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.25), #000 32%, #000 72%, rgba(0, 0, 0, 0.15));
  -webkit-mask-image: linear-gradient(90deg, rgba(0, 0, 0, 0.25), #000 32%, #000 72%, rgba(0, 0, 0, 0.15));
}

.about-hero-lines {
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.08) 50%, transparent 100%) 0 100%/100% 1px no-repeat, linear-gradient(135deg, transparent 0 58%, rgba(254, 90, 51, 0.22) 58% 58.3%, transparent 58.3% 100%);
}

.about-hero-inner {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  align-items: center;
  gap: 48px;
  padding: 58px 0 52px;
}

.about-hero-copy {
  max-width: 720px;
}
.about-hero-copy h1 {
  margin: 0;
  font-size: 42px;
  line-height: 1.16;
  font-weight: 800;
}
.about-hero-copy p {
  margin: 18px 0 0;
  max-width: 660px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  line-height: 1.7;
}

.about-kicker {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 18px;
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  font-weight: 700;
}

.about-kicker-mark {
  width: 30px;
  height: 2px;
  border-radius: 1px;
  background: #FE5A33;
}

.about-hero-snapshot {
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  background: rgba(12, 10, 9, 0.54);
  box-shadow: 0 22px 48px rgba(0, 0, 0, 0.26);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  overflow: hidden;
}

.snapshot-brand {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 18px 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.snapshot-brand img {
  width: 122px;
  height: auto;
}
.snapshot-brand span {
  color: rgba(255, 255, 255, 0.48);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
}

.snapshot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.snapshot-item {
  min-height: 96px;
  padding: 18px;
  border-right: 1px solid rgba(255, 255, 255, 0.08);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.snapshot-item:nth-child(2n) {
  border-right: 0;
}
.snapshot-item:nth-last-child(-n+2) {
  border-bottom: 0;
}

.snapshot-value {
  display: block;
  color: #fff;
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
}

.snapshot-label {
  display: block;
  margin-top: 8px;
  color: rgba(255, 255, 255, 0.54);
  font-size: 16px;
  line-height: 1.5;
}

.snapshot-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 14px 18px 18px;
}
.snapshot-strip span {
  padding: 8px 12px;
  border: 1px solid rgba(254, 90, 51, 0.22);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.72);
  background: rgba(254, 90, 51, 0.1);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
}

/* Vision */
.value-card,
.focus-card,
.rd-metric,
.team-card {
  border-radius: 8px;
  border: 1px solid #e4e4e7;
  background: #fff;
}

.value-card {
  min-height: 220px;
  padding: 24px;
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}
.value-card:hover {
  transform: translateY(-3px);
  border-color: rgba(254, 90, 51, 0.42);
  box-shadow: 0 16px 32px rgba(24, 24, 27, 0.08);
}
.value-card h3 {
  margin: 16px 0 8px;
  color: #18181b;
  font-size: 18px;
  font-weight: 800;
}
.value-card p {
  margin: 0;
  color: #71717a;
  font-size: 16px;
  line-height: 1.65;
}

.value-icon,
.focus-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #fff3ef;
  color: #FE5A33;
}
.value-icon i,
.focus-icon i {
  font-size: 21px;
}

/* Focus */
.about-focus-section {
  padding: 72px 0;
  background: #18181b;
  color: #fff;
}

.focus-header {
  display: grid;
  grid-template-columns: 0.8fr 1.2fr;
  gap: 48px;
  align-items: end;
  margin-bottom: 34px;
}
.focus-header p {
  margin: 0;
  color: rgba(255, 255, 255, 0.64);
  font-size: 18px;
  line-height: 1.7;
}

.focus-card-grid {
  align-items: stretch;
}

.focus-card {
  display: flex;
  min-height: 468px;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  border-color: rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.06);
  color: inherit;
  text-decoration: none;
  box-shadow: 0 22px 46px rgba(0, 0, 0, 0.18);
  transition: transform 0.22s ease, border-color 0.22s ease, background 0.22s ease, box-shadow 0.22s ease;
}
.focus-card:hover, .focus-card:focus-visible {
  border-color: rgba(254, 90, 51, 0.44);
  background: rgba(255, 255, 255, 0.09);
  box-shadow: 0 28px 58px rgba(0, 0, 0, 0.26);
  transform: translateY(-4px);
  outline: none;
}
.focus-card:hover .focus-shot, .focus-card:focus-visible .focus-shot {
  transform: scale(1.04);
}
.focus-card:hover .focus-meta i, .focus-card:focus-visible .focus-meta i {
  transform: translateY(-1px);
}

.focus-visual {
  position: relative;
  height: 206px;
  overflow: hidden;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: #27272a;
}

.focus-shot {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.32s ease;
}

.tone-reviewops .focus-shot {
  object-position: 18% 12%;
}

.tone-dizest .focus-shot {
  object-position: 50% 26%;
}

.tone-wiz .focus-shot,
.tone-works .focus-shot {
  object-position: 50% 50%;
}

.focus-body {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 22px;
}
.focus-body h3 {
  margin: 18px 0 10px;
  color: #fff;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.25;
}
.focus-body p {
  min-height: 104px;
  margin: 0;
  color: rgba(255, 255, 255, 0.62);
  font-size: 16px;
  line-height: 1.62;
}

.focus-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.focus-meta i {
  width: 34px;
  height: 34px;
  flex: 0 0 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: rgba(254, 90, 51, 0.14);
  color: #ff8a65;
  font-size: 18px;
  transition: transform 0.22s ease;
}

.focus-eyebrow {
  color: rgba(255, 255, 255, 0.54);
  font-size: 16px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1.2;
  text-transform: uppercase;
}

.focus-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: auto;
  padding-top: 18px;
}
.focus-tags span {
  display: inline-flex;
  align-items: center;
  min-height: 34px;
  padding: 7px 10px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.09);
  color: rgba(255, 255, 255, 0.72);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}

.tone-reviewops .focus-meta i,
.tone-reviewops .focus-tags span {
  color: #93c5fd;
  background: rgba(37, 99, 235, 0.18);
}

.tone-dizest .focus-meta i,
.tone-dizest .focus-tags span {
  color: #c4b5fd;
  background: rgba(79, 70, 229, 0.2);
}

.tone-wiz .focus-meta i,
.tone-wiz .focus-tags span {
  color: #86efac;
  background: rgba(5, 150, 105, 0.18);
}

.tone-works .focus-meta i,
.tone-works .focus-tags span {
  color: #fde68a;
  background: rgba(202, 138, 4, 0.18);
}

.oedix-mock {
  height: 100%;
  padding: 14px;
  background: linear-gradient(135deg, rgba(254, 90, 51, 0.22), rgba(254, 90, 51, 0) 38%), linear-gradient(135deg, #171717 0%, #27272a 100%);
}

.oedix-window {
  height: 100%;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  background: rgba(12, 10, 9, 0.56);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
}

.oedix-window-head {
  display: flex;
  gap: 5px;
  padding: 10px 11px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.oedix-window-head span {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.42);
}
.oedix-window-head span:first-child {
  background: #FE5A33;
}

.oedix-flow {
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 4px;
  height: calc(100% - 28px);
  padding: 8px 10px;
}

.oedix-node {
  min-width: 0;
  padding: 6px 8px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.07);
}
.oedix-node strong,
.oedix-node span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.oedix-node strong {
  color: #fff;
  font-size: 16px;
  line-height: 1.2;
}
.oedix-node span {
  display: none;
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.56);
  font-size: 16px;
  line-height: 1.25;
}
.oedix-node.is-active {
  border-color: rgba(254, 90, 51, 0.54);
  background: rgba(254, 90, 51, 0.18);
}

.oedix-link {
  width: 2px;
  height: 8px;
  justify-self: center;
  border-radius: 1px;
  background: linear-gradient(180deg, rgba(254, 90, 51, 0.15), rgba(254, 90, 51, 0.9));
}

/* R&D */
.about-rd-section {
  padding: 72px 0;
  background: linear-gradient(180deg, #fafafa 0%, #fff 100%);
  border-bottom: 1px solid #f4f4f5;
}

.rd-metric {
  padding: 24px;
  background: #fff;
  box-shadow: 0 14px 34px rgba(24, 24, 27, 0.05);
}
.rd-metric p {
  margin: 10px 0 0;
  color: #71717a;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.45;
}

.metric-number {
  color: #18181b;
  font-size: 44px;
  font-weight: 800;
  line-height: 1;
}

.metric-plus {
  margin-left: 4px;
  color: #FE5A33;
  font-size: 28px;
  font-weight: 800;
}

/* History */
.history-heading,
.team-heading {
  display: grid;
  grid-template-columns: 0.78fr 1.22fr;
  gap: 48px;
  align-items: end;
  margin-bottom: 34px;
}
.history-heading p,
.team-heading p {
  margin: 0;
  color: #71717a;
  font-size: 18px;
  line-height: 1.7;
}

.history-timeline {
  border-top: 1px solid #e4e4e7;
}

.timeline-year {
  display: grid;
  grid-template-columns: 160px minmax(0, 1fr);
  gap: 32px;
  padding: 28px 0;
  border-bottom: 1px solid #e4e4e7;
}

.timeline-year-label {
  color: #18181b;
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
}

.timeline-items {
  display: grid;
  gap: 12px;
}

.timeline-item {
  display: grid;
  grid-template-columns: 58px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.timeline-month {
  color: #FE5A33;
  font-size: 16px;
  font-weight: 800;
}

.timeline-title {
  color: #3f3f46;
  font-size: 16px;
  line-height: 1.6;
}

/* Team */
.about-team-section {
  padding: 72px 0 88px;
  background: #fafafa;
}

.team-group {
  margin-bottom: 42px;
}
.team-group:last-child {
  margin-bottom: 0;
}

.team-group-heading {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
}
.team-group-heading h3 {
  margin: 0;
  color: #18181b;
  font-size: 22px;
  font-weight: 800;
}
.team-group-heading span {
  color: #71717a;
  font-size: 16px;
  line-height: 1.45;
}

.team-group-icon {
  width: 42px;
  height: 42px;
  flex: 0 0 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
}
.team-group-icon i {
  font-size: 21px;
}

.team-card {
  display: flex;
  gap: 16px;
  align-items: center;
  min-height: 108px;
  padding: 18px;
  background: #fff;
}

.team-avatar {
  width: 72px;
  height: 72px;
  flex: 0 0 72px;
  overflow: hidden;
  border-radius: 8px;
  background: #f4f4f5;
}
.team-avatar img,
.team-avatar .team-avatar-empty {
  width: 100%;
  height: 100%;
}
.team-avatar img {
  display: block;
  object-fit: cover;
}

.team-avatar-empty {
  display: flex;
  align-items: center;
  justify-content: center;
}
.team-avatar-empty i {
  font-size: 28px;
}

.team-group-icon.tone-executive,
.team-avatar-empty.tone-executive {
  color: #FE5A33;
  background: #fff3ef;
}
.team-group-icon.tone-operation,
.team-avatar-empty.tone-operation {
  color: #2563eb;
  background: #eff6ff;
}
.team-group-icon.tone-research,
.team-avatar-empty.tone-research {
  color: #0891b2;
  background: #ecfeff;
}
.team-group-icon.tone-solution,
.team-avatar-empty.tone-solution {
  color: #16a34a;
  background: #f0fdf4;
}
.team-group-icon.tone-default,
.team-avatar-empty.tone-default {
  color: #71717a;
  background: #f4f4f5;
}

.team-info {
  min-width: 0;
}

.team-name {
  margin: 0 0 4px;
  color: #18181b;
  font-size: 17px;
  font-weight: 800;
}

.team-position,
.team-email {
  margin: 0;
  color: #71717a;
  font-size: 16px;
  line-height: 1.5;
}

.team-email {
  color: #a1a1aa;
  word-break: keep-all;
  overflow-wrap: normal;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  color: #a1a1aa;
  text-align: center;
}
.empty-state i {
  margin-bottom: 12px;
  font-size: 38px;
}
.empty-state p {
  margin: 0;
  font-size: 16px;
}

@media (max-width: 1023px) {
  .about-hero-inner,
  .focus-header,
  .history-heading,
  .team-heading {
    grid-template-columns: 1fr;
  }
  .about-hero-inner {
    gap: 28px;
  }
  .about-hero-snapshot {
    max-width: 520px;
  }
  .focus-header,
  .history-heading,
  .team-heading {
    gap: 10px;
  }
}
@media (max-width: 767px) {
  .about-hero {
    min-height: auto;
  }
  .about-hero-inner {
    padding: 42px 0;
  }
  .about-hero-copy h1 {
    font-size: 34px;
  }
  .about-hero-copy p {
    font-size: 16px;
  }
  .about-hero-snapshot {
    display: none;
  }
  .about-focus-section,
  .about-rd-section,
  .about-team-section {
    padding: 56px 0;
  }
  .timeline-year {
    grid-template-columns: 1fr;
    gap: 18px;
  }
  .timeline-item {
    grid-template-columns: 48px minmax(0, 1fr);
    gap: 12px;
  }
  .metric-number {
    font-size: 36px;
  }
}
.about-partner-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 180px), 1fr));
  gap: 20px;
}

.about-partner-logo {
  min-width: 0;
  height: 120px;
  padding: 20px;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
}
.about-partner-logo a, .about-partner-logo div {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.about-partner-logo img {
  max-width: 100%;
  max-height: 80px;
  object-fit: contain;
}
.about-partner-logo a:focus-visible {
  outline: 2px solid #fe5a33;
  outline-offset: 4px;
}`],
})
export class PageAboutComponent implements OnInit {
    public data: any = {};
    public errors: any = {};
    public papersCount: number | null = null;
    public get partners() {
        return partnerRows(this.data.partner, this.service.lang.get() || 'ko');
    }
    public get counters() {
        return {
            papers: this.papersCount === null ? '-' : this.papersCount,
            patents: 8,
            industries: 6,
            partners: this.errors.partner ? '-' : this.partners.length
        };
    }

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
        await this.load();
        await this.service.render();
    }

    private async load() {
        const names = ['history', 'team', 'partner', 'summary'];
        const results = await Promise.allSettled(names.map(name => wiz.call(name)));
        results.forEach((result, index) => {
            const name = names[index];
            const response = result.status === 'fulfilled' ? result.value : null;
            this.errors[name] = response?.code !== 200;
            this.data[name] = this.errors[name] ? {} : response.data;
        });
        if (!this.errors.team) this.data.team = this.sanitizeTeamData(this.data.team);
        this.papersCount = !this.errors.summary && typeof this.data.summary?.papers === 'number'
            ? this.data.summary.papers : null;
        await this.service.render();
    }

    public history() {
        return this.localizedRows(this.data.history);
    }

    public team() {
        return this.localizedRows(this.data.team);
    }

    public loadError() {
        return this.service.lang.get() === 'en'
            ? 'Unable to load this information. Please try again later.'
            : '정보를 불러오지 못했습니다. 잠시 후 다시 확인해주세요.';
    }

    public teamIcon(group: any) {
        const configured = `${group?.icon || ''}`.trim();
        if (configured.indexOf('icon-') === 0) return configured;

        const text = `${group?.team || ''} ${group?.title || ''}`.toLowerCase();
        if (text.includes('경영') || text.includes('executive') || text.includes('ceo')) return 'icon-briefcase';
        if (text.includes('운영') || text.includes('operation')) return 'icon-target';
        if (text.includes('연구') || text.includes('research')) return 'icon-brain-circuit';
        if (text.includes('개발') || text.includes('solution') || text.includes('developer')) return 'icon-code-2';
        return 'icon-users';
    }

    public teamTone(group: any) {
        const icon = this.teamIcon(group);
        if (icon === 'icon-briefcase') return 'tone-executive';
        if (icon === 'icon-target') return 'tone-operation';
        if (icon === 'icon-brain-circuit') return 'tone-research';
        if (icon === 'icon-code-2') return 'tone-solution';
        return 'tone-default';
    }

    public memberPosition(member: any) {
        const affiliation = `${member?.affiliation || ''}`.trim();
        const position = `${member?.position || ''}`.trim();
        if (affiliation && position) return `${affiliation} / ${position}`;
        return affiliation || position;
    }

    public get summaryStats() {
        return [
            { value: '2021', label: 'about.summary.founded' },
            { value: String(this.counters.papers), label: 'about.rd.papers' },
            { value: '8+', label: 'about.rd.patents' },
            { value: String(this.counters.partners), label: 'about.rd.partners' }
        ];
    }

    public values = [
        { icon: 'icon-lightbulb', title: 'about.values.innovation', desc: 'about.values_desc.innovation' },
        { icon: 'icon-accessibility', title: 'about.values.accessibility', desc: 'about.values_desc.accessibility' },
        { icon: 'icon-users', title: 'about.values.collaboration', desc: 'about.values_desc.collaboration' },
        { icon: 'icon-shield-check', title: 'about.values.reliability', desc: 'about.values_desc.reliability' }
    ];

    public focusAreas: FocusArea[] = [
        {
            icon: 'icon-brain-circuit',
            title: 'OEDIX',
            desc: 'about.focus.oedix',
            path: '/solutions/oedix',
            eyebrow: 'Next-gen Orchestration',
            visualType: 'oedix',
            tone: 'tone-oedix',
            tags: ['Task Queue', 'Harness']
        },
        {
            icon: 'icon-clipboard-check',
            title: 'ReviewOps',
            desc: 'about.focus.reviewops',
            path: '/solutions/reviewops',
            eyebrow: 'Review Workflow',
            visualType: 'image',
            image: '/assets/solution/reviewops-screen.png',
            tone: 'tone-reviewops',
            tags: ['Evidence', 'QA']
        },
        {
            icon: 'icon-workflow',
            title: 'Dizest',
            desc: 'about.focus.dizest',
            path: '/solutions/dizest',
            eyebrow: 'Research Workflow',
            visualType: 'image',
            image: '/assets/solution/dizest-screen.gif',
            tone: 'tone-dizest',
            tags: ['Flow Chart', 'AI Lab']
        },
        {
            icon: 'icon-code-2',
            title: 'Wiz',
            desc: 'about.focus.wiz',
            path: '/solutions/wiz',
            eyebrow: 'Web IDE',
            visualType: 'image',
            image: '/assets/solution/wiz-cover.jpg',
            tone: 'tone-wiz',
            tags: ['Builder', 'Plugin']
        },
        {
            icon: 'icon-kanban',
            title: 'SEASON Works',
            desc: 'about.focus.works',
            path: '/solutions/works',
            eyebrow: 'Collaboration',
            visualType: 'image',
            image: '/assets/solution/works-screen.jpg',
            tone: 'tone-works',
            tags: ['Project', 'Message']
        }
    ];

    private localizedRows(data: any) {
        const lang = this.service.lang.get() || 'ko';
        const rows = data?.[lang]?.data;
        if (Array.isArray(rows)) return rows;
        return Array.isArray(data?.ko?.data) ? data.ko.data : [];
    }

    private sanitizeTeamData(data: any) {
        const clone = { ...data };
        ['ko', 'en'].forEach(lang => {
            const rows = clone?.[lang]?.data || [];
            clone[lang] = {
                ...(clone?.[lang] || {}),
                data: rows
                    .filter((group: any) => !!group)
                    .map((group: any) => ({
                        ...group,
                        member: (group.member || []).filter((member: any) => !!member)
                    }))
            };
        });
        return clone;
    }

}

export default PageAboutComponent;